<template>
	<div class="home">
		<News/>
		<Services/>
		<About/>
		<Contacts/>
		<Posts/>
		<Social/>
	</div>
</template>

<script>
import News from '@/components/home/News'
import About from '@/components/home/About'
import Services from '@/components/home/Services'
import Social from '@/components/home/Social'
import Posts from '@/components/home/Posts'
import Contacts from '@/components/home/Contacts'

export default {
	name: 'home',

	components: {
		News,
		About,
		Services,
		Social,
		Posts,
		Contacts
	},
}
</script>

<style lang="stylus" scoped>

</style>